/**
 * Combine two date strings, both of which are optional.
 *
 * e.g. formatDatePair('2020-01-01', '2022-01-02') => '2020 - 2022'
 *
 */
export function formatDatePair(startDate?: string, completionDate?: string): string {
	if (startDate == undefined && completionDate == undefined) {
		return '';
	}

	return `${startDate ? startDate.slice(0, 4) + ' - ' : ''}${
		// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
		completionDate ? completionDate?.slice(0, 4) : ''
	}`;
}
